interface Timerange {
    timeType: string;
    lastDays?: number;
    lastDaysIncludeToday?: boolean;
    startTime?: number | string;
    endTime?: number | string;
}

interface State {
    timerange: Timerange | null;
    activeTabName: string | null;
    includeDays: number;
}

const state: State = {
    timerange: null,
    activeTabName: null,
    includeDays: 7
};

export default {
    namespaced: true,
    state,
    getters: {
        timerange: (state: State) => state.timerange
    },
    mutations: {
        clearPageTimerange(state: State) {
            state.timerange = null;
        },
        setPageTimerange(state: State, timerange: Timerange) {
            state.timerange = timerange;
        },
        setActiveTabName(state: State, val: string) {
            state.activeTabName = val;
        },
        setIncludeDays(state: State, val: string) {
            state.includeDays = val;
        }
    },
    actions: {}
};
